module.exports = __webpack_public_path__ + "static/img/page_bottom.af257391.png";